module.exports = __webpack_public_path__ + "img/illustration-editor.9f3ff282.svg";